import styled from 'styled-components';

const Row = styled.div``;

const size = 12;
const Circle = styled.div`
	height: ${size}px;
	min-width: ${size}px;
	border-radius: ${size / 2}px;
	margin-right: 7px;
	align-items: 'center';
	justify-content: 'center';
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default { Row, Circle };
